import { AxiosRequestConfig } from 'axios';
import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from './query-client';
import {
  Decklist,
  Nullable,
  UserWithToken,
  WithData,
  WithMeta,
} from '@ygoargentina/sdk/api/api.types';
import axiosClient from './request-client';

export const listDecklists = async (
  user: Nullable<UserWithToken>,
  variables: Record<string, unknown>
) =>
  getGraphQLQueryClient(user).request<WithMeta<Decklist>>(
    gql`
      query ($filters: DecklistFilters) {
        data: decklists(filters: $filters) {
          data {
            id
            gameType {
              id
              name
            }
            user {
              id
              name
              lastName
              cossyId
            }
            gameType {
              name
            }
            name
            createdAt
            updatedAt
          }
          meta {
            total
            perPage
            lastPage
          }
        }
      }
    `,
    variables
  );

export const getDecklist = async (
  user: Nullable<UserWithToken>,
  variables: Record<string, unknown>
) =>
  getGraphQLQueryClient(user).request<WithData<Decklist>>(
    gql`
      query ($id: Int!) {
        data: decklist(id: $id) {
          id
          name

          gameType {
            id
            name
          }

          user {
            id
            name
            lastName
            cossyId
          }

          decks {
            main {
              name
              code
              quantity
              inventory {
                quantity
              }
            }
            side {
              name
              code
              quantity
              inventory {
                quantity
              }
            }
            extra {
              name
              code
              quantity
              inventory {
                quantity
              }
            }
          }
          name

          tournaments {
            tournament {
              title
              dateFrom
            }
          }

          createdAt
          updatedAt
        }
      }
    `,
    variables
  );

export const updateDecklist = async (
  user: Nullable<UserWithToken>,
  variables: Record<string, unknown>
) =>
  getGraphQLQueryClient(user).request<Decklist>(
    gql`
      mutation ($id: Int!, $input: UpdateDecklistInput!) {
        data: updateDecklist(id: $id, input: $input) {
          id
        }
      }
    `,
    variables
  );

export const deleteDecklist = async (
  user: Nullable<UserWithToken>,
  variables: Record<string, unknown>
) =>
  getGraphQLQueryClient(user).request<Decklist>(
    gql`
      mutation ($id: Int!) {
        data: deleteDecklist(id: $id) {
          id
        }
      }
    `,
    variables
  );

export const createDecklist = async (
  user: Nullable<UserWithToken>,
  input: Record<string, unknown>
) =>
  getGraphQLQueryClient(user).request<Decklist>(
    gql`
      mutation ($input: CreateDecklistInput!) {
        data: createDecklist(input: $input) {
          id
        }
      }
    `,
    {
      input,
    }
  );

export const mergeDecklists = async (
  user: Nullable<UserWithToken>,
  sourceId: number,
  targetId: number
) =>
  getGraphQLQueryClient(user).request<WithData<Decklist>>(
    gql`
      mutation ($sourceId: Int!, $targetId: Int!) {
        data: mergeDecklists(sourceId: $sourceId, targetId: $targetId) {
          id
          name
        }
      }
    `,
    { sourceId, targetId }
  );

export const importDecklist = (body: FormData, config?: AxiosRequestConfig) =>
  axiosClient.post(`/imports/decklists`, body, {
    ...config,
    headers: {
      ...config?.headers,
      'Content-Type': 'multipart/form-data',
    },
  });
